import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import ContactModal from "../components/ContactModal";
import "../styles/page-terms.css";

const CTA_LABEL = "Begin a partnership";




/* ──────── nav ──────── */



/* ──────── terms header ──────── */

function TermsHeader() {
  return (
    <section className="legal-head" data-screen-label="01 Terms header">
      <div className="wrap">
        <span className="eyebrow">Legal</span>
        <h1><span className="accent">Terms</span> &amp; Conditions</h1>
        <p className="legal-updated">Updated 4 December 2020</p>
      </div>
    </section>);

}

/* ──────── terms body ──────── */

function TermsBody() {
  return (
    <section className="legal-body" data-screen-label="02 Terms body">
      <div className="wrap">
        <div className="legal-col">
          <div className="legal-intro">
            <p>The Upside Digital website &mdash; upsidedigital.com.au (&ldquo;Website&rdquo;) and service (&ldquo;Service&rdquo;) is owned and operated by Upside.Digital Pty Ltd ABN 65 139 669 248 (referred to in these Terms as &lsquo;we&rsquo;).</p>
            <p>The Website assists in connecting users to Australian Service Providers that can compare household services such as electricity and gas, solar and insurance.</p>
            <p>The information contained in this Website does not take into account your objectives, financial situation or particular needs and should not be taken as financial advice. Before using our Service, you should evaluate your own individual needs, objectives and situation.</p>
            <p>The use of this Website is subject to these terms and conditions (&ldquo;Terms&rdquo;). By accessing and using the Website you agree to be bound by these Terms. If you do not agree to these Terms, you must not use or access the Website.</p>
            <p>We may amend these Terms at any time. The amended Terms will be effective from the date at the top of this page. Your continued use of this Website after that date constitutes your acceptance of the amended Terms.</p>
          </div>

          <div className="legal-section">
            <h2>Copyright and trademarks</h2>
            <p>Unless otherwise indicated, we reserve all copyright in the content and design of this Website. We own all such copyright or use it under licence or applicable law.</p>
            <p>You may make a temporary copy of part or all of this website on your local computer for the sole purpose of viewing it, and print a single hard copy of a whole page of this website for personal use, provided that any copyright notice on such page is not removed.</p>
            <p>You may not, in any form, or by any means:</p>
            <ul>
              <li>otherwise reproduce, adapt, store in a retrieval system, transmit, print, display, perform, publish or create derivative works from any part of the content or design of the Website;</li>
              <li>modify or copy the layout of the Website or any computer software or code contained in the Website;</li>
              <li>cause any of the material from the Website to be framed or embedded in another website; or</li>
              <li>commercialise any information, products or services on this Website.</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>Permitted use</h2>
            <p>You may access the Website for your own personal, non-commercial use, subject to restrictions set in these Terms. You are NOT permitted to use the Website in any unlawful or fraudulent manner.</p>
            <p>You agree any information you provide on the Website will be true, accurate and complete.</p>
          </div>

          <div className="legal-section">
            <h2>Payment</h2>
            <p>We provide a Service on the Website which enables you to connect with leading Australian comparison services or direct service providers.</p>
            <p>Our Service is free for you to use. Please note that we do receive a small fee from our third party service providers when an enquiry for their service is made through our Website.</p>
          </div>

          <div className="legal-section">
            <h2>Limitation of liability</h2>
            <p>Upside Digital does not guarantee or warrant the Website will be uninterrupted, without delay, error-free, omission-free, or free of viruses. Therefore, the information is provided &ldquo;as is&rdquo; without warranties of any kind, express or implied, including accuracy, timeliness and completeness.</p>
            <p>To the extent permitted by law, we exclude all liability for loss or damage arising from the use of, or reliance on, the information contained on or accessed through any of the Website. In particular, our partners, directors, employees, agents or related corporate entities will not be liable for any direct, indirect, incidental, special, exemplary, punitive, consequential or other damages whatsoever (including, but not limited to, liability for loss of use, data or profits), without regard to the form of any action, including but not limited to contract, statute, negligence or other tortious actions, arising out of or in connection with the Website, any content on or accessed by use of the Website, or any copying, display or other use of it.</p>
            <p>You assume all risks associated with the use of any of the Websites including, without limitation:</p>
            <ul>
              <li>the risk of your computer, software or data being damaged by any virus which might be transmitted or activated via any of the Website or your access to it; or</li>
              <li>the risk that the content of the Website and any linked websites contravenes the laws of any country outside Australia;</li>
              <li>the risk that any information or material you download from the Website or any linked website infringes third party rights including copyright.</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>Links to or from other sites</h2>
            <p>The Website may contain links to websites controlled or produced by third parties. Except as indicated, we do not control, endorse, sponsor or approve any such websites or any content on them, nor do we provide any warranty or take any responsibility for any aspect of those websites or their content.</p>
          </div>

          <div className="legal-section">
            <h2>Cookies and privacy</h2>
            <p>For details on our use of cookies and how we collect and use personal information via the Websites, see our <Link to="/privacy-policy-and-disclaimer">Privacy Policy</Link>.</p>
          </div>

          <div className="legal-section">
            <h2>Third party services</h2>
            <p>You can apply for a number of services via the Website. These services are not provided by us but are instead provided by third parties over whom we do not have control.</p>
            <p>All third party services offered on the website are Australian operated.</p>
            <p>We are not responsible or liable for any loss or damage you or any third party may suffer or incur in connection with any product you obtain after using a third party service offered on this website or for any acts, omissions, errors or defaults of any third party in connection with this Website.</p>
            <p>By submitting your personal details through this Website, you are giving your express consent to be contacted by our third party provider and agreeing to their Terms and Privacy Policy.</p>
          </div>

          <div className="legal-section">
            <h2>Anti-spam policy</h2>
            <p>We are aware of our responsibilities as a good Internet citizen and are dedicated to protecting the privacy rights of other Internet citizens. We vigorously oppose the sending of unsolicited email (spam).</p>
            <p>It is a requirement that each email message we send out includes an easy way for subscribers to remove themselves via an &ldquo;Unsubscribe&rdquo; link. If a recipient calls our offices and requests to be manually removed from a customer&rsquo;s list, we will manually unsubscribe the recipient from the customer&rsquo;s account.</p>
            <p>To ask questions about this Anti-Spam Policy, or to report spamming activity by one of our customers, please contact our privacy department at: Upside Digital, Level 5 | 501/22 Central Avenue | Manly | NSW 2095 | Australia.</p>
            <p>For the purposes of the <em>Do Not Call Register Act 2006</em> (Cth) &mdash; by submitting your telephone number to the website, you give your express consent to be contacted by telephone on that number either by us OR our Third Party service provider.</p>
            <p>Subscribers who sign up to the Website are deemed to provide their consent to be contacted by email, phone, text, or post with more interesting promotion offers we publish.</p>
            <p>Subscribers who choose to opt in / consent to any client advertisements or promotions will be consenting to share selected information given by themselves on this site directly to the relevant third party service provider.</p>
          </div>

          <div className="legal-section">
            <h2>Applicable law</h2>
            <p>The Website is hosted on web servers in Australia or the United States.</p>
            <p>These conditions and all other specific and additional terms which govern your use and access to the Site will be governed by and construed in accordance with the laws of the state of New South Wales, Australia.</p>
          </div>
        </div>
      </div>
    </section>);

}

/* ──────── footer ──────── */

function TermsPage() {
  const [csOpen, setCsOpen] = useState(false);

  useEffect(() => {document.body.setAttribute("data-density", "standard");}, []);

  const openCs = (e) => {if (e) e.preventDefault();setCsOpen(true);};

  return (
    <div className="page page-terms">
      <Nav onCta={openCs} ctaLabel={CTA_LABEL} />
      <TermsHeader />
      <TermsBody />
      <Footer onContact={openCs} />

      <ContactModal open={csOpen} onClose={() => setCsOpen(false)} />
    </div>);

}

export default TermsPage;
